/**
 * German (Deutsch) language translations.
 * Format: {'property': 'translation value';}
 */
export const LANG_DE_TRANS = {
    // menu
    'lvt.menu.twroute': 'Routes',
    'lvt.menu.twcalloff': 'twCalloff',
    'lvt.menu.twslot': 'twSlot',
    'lvt.menu.slot_booking': 'Smart Booking',
    'lvt.menu.twdoc': 'twDoc',
    'lvt.menu.twcost': 'twCost',
    'lvt.menu.lvt': 'Live Tracking',
    'lvt.menu.app_name': 'Transwide',
    'lvt.menu.my_profile': 'Mein Profil',
    'lvt.menu.tw_profile': 'TW Profil',
    'lvt.menu.company_profile': 'Unternehmensprofil',
    'lvt.menu.my_notifications': 'Meine Benachrichtigungen',
    'lvt.menu.sign_out': 'Abmelden',

    // footer
    'lvt.footer.back_to_top': 'Zurück zum Anfang',
    'lvt.footer.terms_of_use': 'Nutzungsbedingungen',
    'lvt.footer.privacy_policy': 'Datenschutzerklärung',
    'lvt.footer.support_information': 'Support',
    'lvt.footer.transwide_home': 'Transwide Home',
    'lvt.footer.license_nr': 'Lizenznr.:',
    'lvt.footer.build_version': 'Build-Version:',

    // order list columns
    'lvt.order_list.header': 'List der Aufträge',
    'lvt.order_list.column.shipperCompany': 'Speditionsunternehmen',
    'lvt.order_list.column.reference': 'Referenz',
    'lvt.order_list.column.status': 'Status',
    'lvt.order_list.column.statusReason': 'Statusgrund',
    'lvt.order_list.column.senderCompany': 'Versender',
    'lvt.order_list.column.senderZipcode': 'Versender PLZ',
    'lvt.order_list.column.senderCity': 'Ort Versender',
    'lvt.order_list.column.receiverCompany': 'Empfänger',
    'lvt.order_list.column.receiverZipcode': 'Empfänger PLZ',
    'lvt.order_list.column.receiverCity': 'Ort Empfänger',
    'lvt.order_list.column.carrierName': 'Name des Frachtführers',
    'lvt.order_list.column.plannedPickupEndDate': 'Geplante Abholung',
    'lvt.order_list.column.etaPickup': 'ETA bei Abholung',
    'lvt.order_list.column.delayAtPickup': 'Verzögerung bei Abholung',
    'lvt.order_list.column.plannedDeliveryEndDate': 'Geplante Anlieferung',
    'lvt.order_list.column.etaDelivery': 'ETA bei Anlieferung',
    'lvt.order_list.column.delayAtDelivery': 'Verzögerung bei Anlieferung',
    'lvt.order_list.column.timestamps': 'Timestamps',
    'lvt.order_list.column.bookingPickupTime': 'Booking pickup',
    'lvt.order_list.column.bookingDeliveryTime': 'Booking delivery',

    // status order list
    'lvt.order_list.status.requested': 'Erbeten',
    'lvt.order_list.status.failed': 'Fehler',
    'lvt.order_list.status.waiting': 'Warten',
    'lvt.order_list.status.active': 'Aktiv',
    'lvt.order_list.status.stopped': 'Fehler',
    'lvt.order_list.status.completed': 'Erledigt',
    'lvt.order_list.status.cancelled': 'Storniert',
    'lvt.order_list.status.timeout': 'Abgebrochen',

    // status reason order list
    'lvt.order_list.status_reason.carrier_not_assigned': 'Frachtführer nicht zugeordnet',
    'lvt.order_list.status_reason.plate_number_not_present': 'Kennzeichen nicht vorhanden',
    'lvt.order_list.status_reason.plate_number_not_recognized': 'Kennzeichen nicht erkannt',
    'lvt.order_list.status_reason.plate_number_not_operational': 'Kennzeichen nicht in Betrieb',
    'lvt.order_list.status_reason.technical_error_not_posted': 'Technical error when creating the tour in GH',

    // pagination
    'lvt.order_list.pagination.rows_per_page': 'Zeilen pro Seite',
    'lvt.order_list.pagination.first': 'Erste',
    'lvt.order_list.pagination.previous': 'Vorherige',
    'lvt.order_list.pagination.next': 'Nächste',
    'lvt.order_list.pagination.last': 'Letzte',
    'lvt.order_list.pagination.no_orders_found': 'Keine Aufträge gefunden',

    // tracked device
    'lvt.map.tracked_device.trailer': 'Zug',
    'lvt.map.tracked_device.tractor': 'Zugmaschine',
    'lvt.map.tracked_device.mobile': 'Mobil',

    // map
    'lvt.map.button.open_settings': 'Open settings',
    'lvt.map.button.open_order_list': 'List der offenen Aufträge',
    'lvt.map.traffic_information.traffic': 'Traffic',
    'lvt.map.traffic_information.fast': 'Fast',
    'lvt.map.traffic_information.slow': 'Slow',
    'lvt.map.pickup_popup.pickup': 'Abholung',
    'lvt.map.pickup_popup.date': 'Datum',
    'lvt.map.pickup_popup.address': 'Adresse',
    'lvt.map.delivery_popup.delivery': 'Anlieferung',
    'lvt.map.delivery_popup.date': 'Datum',
    'lvt.map.delivery_popup.address': 'Adresse',
    'lvt.map.current_gps_popup.in_transit_to_at_delivery': 'Auf dem Weg zur Zustellung',
    'lvt.map.current_gps_popup.in_transit_to_at_pickup': 'Auf dem Weg zur Abholung',
    'lvt.map.current_gps_popup.current_speed': 'Aktuelles Tempo',
    'lvt.map.current_gps_popup.average_speed': 'Durchschnittliches Tempo',
    'lvt.map.current_gps_popup.last_location_update': 'Letzte Standort-Aktualisierung',
    'lvt.map.current_gps_popup.eta': 'ETA',
    'lvt.map.current_gps_popup.planned_time': 'Geplante Zeit',
    'lvt.map.current_gps_popup.arrival_delay': 'Ankunftsverzögerung',
    'lvt.map.current_gps_popup.speed_unit': 'km/st.',

    // timestamps
    'lvt.order_list.timestamp.arrived_at_origin': 'Am Ursprungsort angekommen',
    'lvt.order_list.timestamp.not_arrived_at_origin': 'Nicht am Ursprungsort angekommen',
    'lvt.order_list.timestamp.left_origin': 'Ursprungsort verlassen',
    'lvt.order_list.timestamp.not_left_origin': 'Ursprungsort nicht verlassen',
    'lvt.order_list.timestamp.arrived_at_destination': 'Am Zielort angekommen',
    'lvt.order_list.timestamp.not_arrived_at_destination': 'Nicht am Zielort angekommen',
    'lvt.order_list.timestamp.left_destination': 'Zielort verlassen',
    'lvt.order_list.timestamp.not_left_destination': 'Zielort nicht verlassen',

    // settings
    'lvt.settings.header': 'Settings',
    'lvt.settings.delay_management': 'Delay management',
    'lvt.settings.add_new': 'Add new +',
    'lvt.settings.column.ruleTitle': 'Rule title',
    'lvt.settings.column.type': 'Type',
    'lvt.settings.column.offset': 'Offset',
    'lvt.settings.column.actions': 'Actions',
    'lvt.settings.create_rule': 'Create rule',
    'lvt.settings.view_rule': 'View rule',
    'lvt.settings.go_back_to_list': 'Go back to list',
    'lvt.settings.edit_rule': 'Modify rule',
    'lvt.settings.delete_rule': 'Delete rule',
    'lvt.settings.delete_this_rule': 'Delete this rule',
    'lvt.settings.rule_type.delay': 'Delay',
    'lvt.settings.rule_type.at_risk': 'At risk',
    'lvt.settings.no_rules_found': 'No rules found',
    'lvt.settings.delete_popup.message': 'Are you sure you want to delete this rule?',
    'lvt.settings.field.rule_title': 'Rule title',
    'lvt.settings.field.location_type': 'Location type',
    'lvt.settings.field.location_type_pickup': 'Pickup',
    'lvt.settings.field.location_type_delivery': 'Delivery',
    'lvt.settings.field.rule_type': 'Rule type',
    'lvt.settings.field.rule_type_delay.time_offset': 'Time offset threshold',
    'lvt.settings.field.rule_type_delay.unit_minutes': 'Minutes',
    'lvt.settings.field.rule_type_delay.unit_hours': 'Hours',
    'lvt.settings.field.rule_type_delay.before': 'Before',
    'lvt.settings.field.rule_type_delay.after': 'After',
    'lvt.settings.field.rule_type_atrisk.percentage': 'Percentage threshold',
    'lvt.settings.field.schedule_date_priority': 'Schedule date priority',
    'lvt.settings.field.schedule_date_priority.booking_time': 'Booked timeslot',
    'lvt.settings.field.schedule_date_priority.planned_earliest_arrival': 'Earliest planned arrival',
    'lvt.settings.field.schedule_date_priority.planned_latest_arrival': 'Latest planned arrival',
    'lvt.settings.field.error.required': 'is required',

    // popup
    'lvt.popup.yes': 'Yes',
    'lvt.popup.cancel': 'Cancel',

    // messages from backend
    'lvt.message.info_saved_successfully': 'Info saved successfully.',
    'lvt.message.info_updated_successfully': 'Info updated successfully.',
    'lvt.message.info_deleted_successfully': 'Info deleted successfully.',
    'lvt.message.warn': 'Warning: ',
    'lvt.message.error': 'Error: ',
    'lvt.message.error_no_name_specified': 'No name specified.',
    'lvt.message.error_no_company_id_specified': 'No company Id specified.',
    'lvt.message.error_no_location_type_specified': 'No location type specified.',
    'lvt.message.error_no_rule_type_specified': 'No rule type specified.',
    'lvt.message.error_date_priorities_not_specified': 'Date priorities not specified.',
    'lvt.message.error_delay_offset_not_specified': 'Delay offset not specified.',
    'lvt.message.error_at_risk_offset_not_specified': 'At risk offset not specified.',
    'lvt.message.error_no_entity_found': 'No entity found.',
    'lvt.message.error_could_not_convert_delay_rule': 'Could not convert delay rule.',

    // search
    'lvt.order_list.search': 'Search'
};



// WEBPACK FOOTER //
// ./src/app/services/translation/lang/lang-de.ts